'use client';

import type { NotificationAuthorizations } from '@/types/user/enums';
import type { User } from '@/types/user/type';
import { fetchItem } from '@/app/actions/server';
import { Loader } from '@/app/components/Loader';
import { NotificationsForm } from '@/app/components/Notifications/NotificationsForm';
import { useApiErrorContext, useAuthenticatedContext } from '@/app/components/Provider';
import { useRequestState } from '~/hooks/request/useRequestState';

export const Notifications = () => {
  const { user, setUser } = useAuthenticatedContext();
  const { setError } = useApiErrorContext();

  const { startRequest, handleSuccess, handleError, status } = useRequestState();

  const isPending = status === 'pending';

  const handleUpdateSubscription = async (
    subscriptionList: NotificationAuthorizations[],
  ) => {
    const putData = {
      notification_authorizations: subscriptionList,
    };

    startRequest();

    const response = await fetchItem<User>({
      pathname: 'users/me',
      method: 'PUT',
      body: putData,
      revalidate: 0,
    });

    if (response['hydra:description']) {
      handleError();
      return setError(response);
    }

    setUser(response);

    handleSuccess();
  };

  return (
    <Loader loading={isPending}>
      <NotificationsForm
        userSubscription={user?.notification_authorizations}
        handleUpdateSubscription={handleUpdateSubscription}
      />
    </Loader>
  );
};
